import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../notification/Notification";
import MsCashNetworkSelect from "./MsCashNetworkSelect";
import MsCashCitySelect from "./MsCashCitySelect";
import MsCashManagerSelect from "./MsCashManagerSelect";
import { MS_CASH, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

const MsCashAttributes = ({ invoiceData, setInvoiceData }) => {

  const [attributes, setAttributes] = useState([]);
  const [fetchingAttributes, setFetchingAttributes] = useState(true);

  const [networks, setNetworks] = useState();
  const [checkedNetwork, setCheckedNetwork] = useState();

  const [cities, setCities] = useState();
  const [checkedCity, setCheckedCity] = useState();

  const [managers, setManagers] = useState();
  const [checkedManager, setCheckedManager] = useState();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchNetworks = (data) => {
    let fetchingData = [];

    data && data.map(value => {
      fetchingData.push({ id: value.network.id, name: value.network.name });
    });

    return fetchingData;
  };

  const fetchCities = () => {
    let fetchingData = [];

    attributes && attributes.map(value => {
      if (checkedNetwork.id !== value["network"]["id"]) {
        return;
      }

      for (let [key, val] of Object.entries(value["cities"])) {
        fetchingData.push(val["city"]);
      }
    });

    return fetchingData;
  };

  const fetchManagers = () => {
    let fetchingData = {};

    attributes && attributes.map(value => {
      if (checkedNetwork.id !== value["network"]["id"]) {
        return;
      }

      for (let [key, val] of Object.entries(value["cities"])) {
        if (!checkedCity || checkedCity.id !== val["city"].id) {
          continue;
        }

        fetchingData = val["cashiers"];
      }
    });

    return fetchingData;
  };

  const fetchAttributes = () => {
    let fetchingData = [];

    invoiceData.attributes.map(value => {
      if (value.name === "networkId") {
        fetchingData.push({ "id": value.id, "value": checkedNetwork.id.toString(), "name": value.name });
      }

      if (value.name === "cityId") {
        fetchingData.push({ "id": value.id, "value": checkedCity.id.toString(), "name": value.name });
      }

      if (value.name === "cashierId" && checkedManager) {
        fetchingData.push({ "id": value.id, "value": checkedManager.email.match(/\d+/)[0].toString(), "name": value.name });
      }
    });

    return fetchingData;
  };

  useEffect(() => {
    axios.get("/api/network", userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setAttributes(response.data.data);
        setNetworks(fetchNetworks(response.data.data));
        setFetchingAttributes(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  useEffect(() => {
    setCities(fetchCities());
    setCheckedCity(null);
    setCheckedManager(null);
  }, [checkedNetwork]);

  useEffect(() => {
    let managers = fetchManagers();
    setCheckedManager(null);
    setManagers(managers);

    if (!managers) {
      setInvoiceData({ ...invoiceData, "attributes": fetchAttributes() });
    }
  }, [checkedCity]);

  useEffect(() => {
    if (checkedManager) {
      setInvoiceData({ ...invoiceData, "attributes": fetchAttributes() });
    }
  }, [checkedManager]);

  if (invoiceData.service.name !== MS_CASH) {
    return <></>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <MsCashNetworkSelect
        networks={networks}
        checkedNetwork={checkedNetwork}
        setCheckedNetwork={setCheckedNetwork}
        fetchingNetworks={fetchingAttributes}
      />
      {cities && Object.keys(cities).length !== 0 && <MsCashCitySelect
        cities={cities}
        checkedCity={checkedCity}
        setCheckedCity={setCheckedCity}
      />}
      {managers && Object.keys(managers).length !== 0 && <MsCashManagerSelect
        managers={managers}
        checkedManager={checkedManager}
        setCheckedManager={setCheckedManager}
      />}
    </>
  );
};

export default MsCashAttributes;